import React from "react";

const WhyChooseUss = () => {
  return (
    <div className="sis-why-choose-us-section sisf-page-background sis-br-radius py-2">
      <div className="container">

        {/* =========================================
            SECTION INTRO
        ========================================== */}
        <div className="row">
          <div className="col-lg-9">

            <div className="sisf-sis-section-title sis-section-title">

              <span className="sisf-m-subtitle white sis-text-anime-style-3">
                WHY CHOOSE CITYSKY CABS
              </span>

              <h2 className="sisf-m-title text-white sis-text-anime-style-3">
                Reliable Cab Service in Pune for Local, Airport, Corporate
                &amp; Outstation Travel
              </h2>

              <div
                className="sisf-m-text"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <p className="text-white">
                  CitySky Cabs provides convenient and reliable cab rental
                  services in Pune for local journeys, airport transfers,
                  corporate transportation, outstation trips, family tours
                  and group travel. Choose from suitable vehicle options
                  including sedans, SUVs, Ertiga, Innova, Innova Crysta,
                  Tempo Traveller, Urbania, Mini Bus and Bus according to
                  your travel requirements.
                </p>
              </div>

              <div
                className="sisf-m-button pt-4 mt-2"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <a href="/our-fleet" className="sis-btn-default btn-light">
                  Explore Our Fleet
                  <i className="fa-solid fa-arrow-right-long"></i>
                </a>
              </div>

            </div>

          </div>

          <div className="col-lg-3"></div>
        </div>


        {/* =========================================
            WHY CHOOSE CARDS
        ========================================== */}
        <div className="row">

          {/* =====================================
              CARD 01
          ====================================== */}
          <div className="col-lg-4 col-md-6">

            <div
              className="sisf-why-choose-contents p-4 overflow-hidden sis-radius"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="sisf-e-inner position-relative">

                <div className="sisf-e-content">

                  <div className="sisf-m-count">
                    <span>01</span>
                  </div>

                  <div className="sis-e-title mb-2">
                    <h3 className="text-white">
                      Professional &amp; Reliable Service
                    </h3>
                  </div>

                  <div className="sis-e-text">
                    <p className="text-white mb-0">
                      Travel with professional drivers and suitable vehicles
                      for local trips, airport transfers, business travel,
                      family journeys and long-distance outstation routes.
                    </p>
                  </div>

                </div>

                {/* <div className="sisf-why-choose-image-bottom text-end">
                  <figure>
                    <img
                      src="/images/car-image-3.png"
                      alt="CitySky Cabs Professional Cab Service in Pune"
                    />
                  </figure>
                </div> */}

              </div>
            </div>

          </div>


          {/* =====================================
              CARD 02
          ====================================== */}
          <div className="col-lg-4 col-md-6">

            <div
              className="sisf-why-choose-contents p-4 overflow-hidden sis-radius"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="sisf-e-inner position-relative">

                <div className="sisf-e-content">

                  <div className="sisf-m-count">
                    <span>02</span>
                  </div>

                  <div className="sis-e-title mb-2">
                    <h3 className="text-white">
                      Quick &amp; Easy Cab Booking
                    </h3>
                  </div>

                  <div className="sis-e-text">
                    <p className="text-white mb-0">
                      Book your CitySky Cab quickly for one-way, round trip,
                      local, airport or outstation travel with convenient
                      booking assistance from our team.
                    </p>
                  </div>

                </div>

                {/* <div className="sisf-why-choose-image-bottom text-end">
                  <figure>
                    <img
                      src="/images/car-image-2.png"
                      alt="CitySky Cabs Easy Cab Booking Pune"
                    />
                  </figure>
                </div> */}

              </div>
            </div>

          </div>


          {/* =====================================
              CARD 03
          ====================================== */}
          <div className="col-lg-4 col-md-6">

            <div
              className="sisf-why-choose-contents p-4 overflow-hidden sis-radius"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="sisf-e-inner position-relative">

                <div className="sisf-e-content">

                  <div className="sisf-m-count">
                    <span>03</span>
                  </div>

                  <div className="sis-e-title mb-2">
                    <h3 className="text-white">
                      Multiple Vehicle Options
                    </h3>
                  </div>

                  <div className="sis-e-text">
                    <p className="text-white mb-0">
                      Choose the right vehicle for your journey from Sedan,
                      Ertiga, Innova, Innova Crysta, Tempo Traveller,
                      Force Urbania, Mini Bus and Bus options.
                    </p>
                  </div>

                </div>

                {/* <div className="sisf-why-choose-image-bottom text-end">
                  <figure>
                    <img
                      src="/images/car-image-1.png"
                      alt="CitySky Cabs Vehicle Fleet Pune"
                    />
                  </figure>
                </div> */}

              </div>
            </div>

          </div>

        </div>


        {/* =========================================
            BOTTOM CTA
        ========================================== */}
        <div className="row">
          <div className="col-12">

            <div className="sis-comman-bottom-line-text d-flex align-items-center justify-content-center gap-3">

              <div
                className="sisf-users-image"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <figure>
                  <img
                    src="/images/users3.png"
                    alt="CitySky Cabs Customers"
                  />
                </figure>
              </div>

              <div
                className="sisf-sis-e-box d-flex align-items-center justify-content-center"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <p className="mb-0 text-white">
                  Find the right vehicle for your next journey —{" "}
                  <a
                    href="/our-fleet"
                    className="text-white border-bottom border-white"
                  >
                    View Our Complete Fleet
                  </a>
                </p>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default WhyChooseUss;